"use client";

import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export type PitchAboutSectionProps = {
  children: ReactNode;
};

export default function PitchAboutSection({ children }: PitchAboutSectionProps) {
  const { t } = useTranslation();

  return (
    <div className="mb-10 rounded-2xl border border-slate-200/80 bg-gradient-to-br from-slate-50 via-white to-slate-50/80 p-6 shadow-[0_2px_20px_-14px_rgba(15,23,42,0.1)] md:p-8">
      <h2 className="mb-4 text-xl font-bold tracking-tight text-slate-900 sm:text-2xl">
        {t("canchaPitchPage.aboutVenueTitle")}
      </h2>
      <div className="space-y-4 text-sm leading-relaxed text-slate-600 sm:text-base">{children}</div>
    </div>
  );
}
